"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Avatar = Avatar;

var _loading = require("../loading");

var _styles = require("react-components/styles");

var _styledTools = require("styled-tools");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _excluded = ["children", "isLoading", "spinner"];

var _templateObject;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/**
 * `Wrapper` styled component.
 */
var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "avatar__Wrapper",
  componentId: "sc-nkd7xs-0"
})(["align-items:center;clip-path:url(#slyk-mask);display:flex;font-size:14px;font-weight:400;justify-content:center;letter-spacing:-0.2px;line-height:20px;overflow:hidden;position:relative;", " ", " ", ""], (0, _styledTools.switchProp)('colorTheme', {
  gray: (0, _styledComponents.css)(["background-color:", ";color:", ";"], (0, _styles.color)('gray500'), (0, _styles.color)('white')),
  primary: (0, _styledComponents.css)(["background-color:", ";color:", ";"], (0, _styles.color)('primary'), (0, _styles.color)('white')),
  transparent: (0, _styledComponents.css)(["background-color:transparent;"])
}), (0, _styledTools.switchProp)('size', {
  extraLarge: (0, _styledComponents.css)(["height:72px;width:72px;"]),
  large: (0, _styledComponents.css)(["height:56px;width:56px;"]),
  medium: (0, _styledComponents.css)(["height:40px;width:40px;"]),
  small: (0, _styledComponents.css)(["height:32px;width:32px;"])
}, (0, _styledComponents.css)(["height:", ";width:", ";"], (0, _styledTools.prop)('size'), (0, _styledTools.prop)('size'))), _styles.media.min('md')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    font-size: 16px;\n    font-weight: 700;\n    line-height: 22px;\n  "]))));
/**
 * Export `Avatar` component.
 */


function Avatar(props) {
  var children = props.children,
      isLoading = props.isLoading,
      spinner = props.spinner,
      rest = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/_react["default"].createElement(Wrapper, rest, isLoading ? /*#__PURE__*/_react["default"].createElement(_loading.Loading, {
    active: true,
    spinner: spinner
  }) : children);
}